import moment from 'moment';
import { SET_TEXT_FILTER, SORT_BY_EFFECTIVE_DATE, SORT_BY_POSTED_DATE, SORT_BY_AMOUNT, SET_START_DATE, SET_END_DATE, SEARCH_BY_VENDOR, SEARCH_BY_PURPOSE, SEARCH_BY_ENTRY_NUMBER, DISPLAY_DIVISION } from '../actions/filterActions';

const INITIAL_STATE = {
  text: '',
  sortBy: 'effectiveDate',
  searchBy: 'entry_number',
  showDivison: 'All',
  startDate: moment().startOf('day'),
  endDate: moment().endOf('day')
};

export default(state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_TEXT_FILTER:
      return {
        ...state,
        text: action.text
      };
    case DISPLAY_DIVISION:
      return {
        ...state, showDivison: action.division
      };
    // Sort By Methods
    case SORT_BY_EFFECTIVE_DATE:
      return {
        ...state,
        sortBy: 'effectiveDate'
      };
    case SORT_BY_POSTED_DATE:
      return {
        ...state,
        sortBy: 'postedDate'
      };
    case SORT_BY_AMOUNT:
      return {
        ...state,
        sortBy: 'amount'
      };

    // Search by methods
    case SEARCH_BY_VENDOR:
      return {
        ...state,
        searchBy: 'vendor'
      };
    case SEARCH_BY_PURPOSE:
      return {
        ...state,
        searchBy: 'purpose'
      };
    case SEARCH_BY_ENTRY_NUMBER:
      return {
        ...state,
        searchBy: 'entry_number'
      };
    // Date Methods
    case SET_START_DATE:
      return {
        ...state, startDate: action.startDate
      };
    case SET_END_DATE:
      return {
        ...state, endDate: action.endDate
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/filtersReducer.js